import axios from 'axios';
import cookie from 'js-cookie';
import cookieHelper from 'cookie';

// Types
import { SET_KEYCLOAK_USER_DETAILS } from '../user/types';
import { KeycloakUserDetails } from '../../../core/types/AffiliateDetails';
// Redux
import { getAffiliateDetails } from '../user/actions';
import { userAuthRequestStart, userAuthRequestSuccess, userAuthRequestFail } from '../user/actions';
import { getServicesErrorObj } from '../servicesDowntime/actions';
// Utils
import { getBasicAuthToken } from '../../../core/utils/BasicAuthTokenGetter';
import { getReferringCompany } from '../../../core/utils/ReferringCompanyValueGetter/ReferringCompanyValueGetter';
import { TokenManager } from '../../../core/utils/TokenManager';
// Constants
import { ORGANIZATION__CODE_MAPPING, ORG_CODE_MAPPING_FOR_LOCATION_LOOKUP } from '../../../core/utils/Constants/Constants';

const USER_THIRD_PARTY_AUTH_URL = (token: string) => `/affiliate-portal/UserDetails?token=${token}`;

const AFFILIATE_NUMBER_KEY: string = "affiliate-number";
const AFFILIATE_ID_KEY: string = "affiliate-id";
const AFFILIATE_EMAIL_ID: string = "affiliate-email";
const AUTHENTICATED_BY_OCTA: string = "authenticated_by_octa";

const REFRESH_TOKEN_EXPIRY: number = 29 / 1440;
const COOKIE_PATH = '/';

export const setKeycloakUserDetailsObj = (payload: any) => ({
  type: SET_KEYCLOAK_USER_DETAILS,
  payload
});

export const updateKeycloakUserDetails = (payload: any) =>
  (dispatch: Function) => {
    dispatch(setKeycloakUserDetailsObj(payload));
  };

export const thirdPartyAuthenticate = (requestParams: any) => (dispatch: Function) =>
  new Promise((resolve, reject) => {
    const referringCompany = getReferringCompany();
    const BASIC_AUTH_TOKEN = getBasicAuthToken(referringCompany);

    const Organization: string = ORGANIZATION__CODE_MAPPING[referringCompany];
    const organizationCode: string = ORG_CODE_MAPPING_FOR_LOCATION_LOOKUP[Organization];

    const { token } = requestParams;

    axios(USER_THIRD_PARTY_AUTH_URL(token), {
      method: "GET",
      withCredentials: true,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Basic ${BASIC_AUTH_TOKEN}`,
        'X-Organization': organizationCode
      },
    })
      .then((response) => {
        if (response.data) {
          const {
            access_token,
            refresh_token,
            affiliate_number,
            affiliate_id,
            username
          } = response.data;

          TokenManager.setAccessToken(access_token);
          TokenManager.setRefreshToken(refresh_token, REFRESH_TOKEN_EXPIRY);

          affiliate_id && cookie.set(AFFILIATE_ID_KEY, affiliate_id, {
            path: COOKIE_PATH
          });

          affiliate_number && affiliate_number.length > 0 && cookie.set(AFFILIATE_NUMBER_KEY, affiliate_number, {
            path: COOKIE_PATH
          });

          affiliate_number && affiliate_number.length > 0 && sessionStorage.setItem(AFFILIATE_NUMBER_KEY, affiliate_number);
          affiliate_id && affiliate_id.length > 0 && sessionStorage.setItem(AFFILIATE_ID_KEY, affiliate_id);
          username && sessionStorage.setItem(AFFILIATE_EMAIL_ID, username);

          sessionStorage.setItem(AUTHENTICATED_BY_OCTA, 'true');
        }

        dispatch(getAffiliateDetails()).then(() => {
          const userDetailPayload: KeycloakUserDetails = {
            ...response.data,
            isKeycloakAuthenticated: true
          };

          updateKeycloakUserDetails(userDetailPayload);

          resolve(response);
        }).catch((error) => {
          reject(error);
        })
      })
      .catch((error) => {
        reject(error);
      });
  });

export const authenticateUser = (requestParams) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(userAuthRequestStart());

  const callAuthenticate = () => {
    dispatch(thirdPartyAuthenticate(requestParams))
      .then((response: any) => {
        dispatch(userAuthRequestSuccess({}));
        resolve(response);
      })
      .catch((error: any) => {
        dispatch(userAuthRequestFail());
        dispatch(getServicesErrorObj(error));
        reject(error);
      });
  };

  const checkBasicAuthToken = () => {

    callAuthenticate();

    console.log('checkBasicAuthToken called');
    console.log('checkBasicAuthToken referringCompany', getReferringCompany());
    console.log('checkBasicAuthToken cdhCompany', cookieHelper.parse(document.cookie).cdhCompany);
  };

  checkBasicAuthToken();
});